import { useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// This component is used to display a notice/success/error alert on the UI
const CustomAlert = ({ type, title, message }) => {
    // Map our alert types to react-toastify types
    const getToastType = () => {
        switch (type) {
            case "success":
                return "success";
            case "error":
                return "error";
            case "notice":
            default:
                return "info";
        }
    };

    // Get custom styles based on alert type
    const getAlertStyles = () => {
        switch (type) {
            case "success":
                return {
                    background: "rgba(220, 252, 231, 0.95)",
                    borderColor: "#86efac",
                    color: "#166534"
                };
            case "error":
                return {
                    background: "rgba(254, 226, 226, 0.95)",
                    borderColor: "#fca5a5",
                    color: "#991b1b"
                };
            case "notice":
            default:
                return {
                    background: "rgba(241, 245, 249, 0.95)",
                    borderColor: "#cbd5e1",
                    color: "#475569"
                };
        }
    };

    // Show the toast notification only once when the component mounts
    useEffect(() => {
        // Only show toast if all required props are provided
        if (type && title && message) {
            toast(
                <div>
                    <div style={{ fontWeight: "600", fontSize: "1.1rem", marginBottom: "8px" }}>{title}</div>
                    <div style={{ fontSize: "0.95rem" }}>{message}</div>
                </div>,
                {
                    type: getToastType(),
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: getAlertStyles().background,
                        color: getAlertStyles().color,
                        border: `1px solid ${getAlertStyles().borderColor}`,
                        borderRadius: "12px",
                        boxShadow: "0 8px 16px rgba(0,0,0,0.08)",
                        backdropFilter: "blur(8px)",
                        direction: "rtl",
                        textAlign: "right",
                    }
                }
            );
        }
    }, [type, title, message]); // Only re-run if these props change

    // Return null as the component doesn't render anything directly
    return null;
};

export default CustomAlert;
